import { ChoicesArticleCombination } from "@generated"
import { productHasRequiredArgsForConfigurator } from "./product-has-required-args-for-configurator"
import * as qs from "query-string"

export function getCustomizeUrl(
  item: ChoicesArticleCombination,
  type: "ring" | "earring" | "bracelet" | "necklace"
): string | undefined {
  // Only rings and earring that DONT have a fixed component are configurable
  if (
    (type === "ring" || type === "earring") &&
    !item.hasFixedComponent &&
    item.style !== "onepiece"
  ) {
    let args = {
      style: item.style,
      type,
    }
    if (item.size) {
      args["size"] = item.size
    }

    if (item.substyle) {
      args["substyle"] = item.substyle
    }

    if (item.style === "hippiechic") {
      args["material"] = item.baseMaterial
    }

    if (item.articles) {
      const frame = item.articles.filter((a) => a.component === "Frame")
      const base = item.articles.filter((a) => a.component === "Base")
      const stone = item.articles.filter((a) => a.component === "Stone")
      if (frame[0]) {
        args["frame"] = frame[0].id
      }
      if (base[0]) {
        args["base"] = base[0].id
      }
      if (stone[0]) {
        args["stone"] = stone[0].id
      }
    }

    const hasRequiredConfiguratorArgs = productHasRequiredArgsForConfigurator(
      args,
      type
    )

    return hasRequiredConfiguratorArgs
      ? `/configurator?${qs.stringify(args)}`
      : undefined
  }

  return undefined
}
